import LogoMark from "./BrandMark";
﻿import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Tooltip,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, NavLink } from "react-router-dom";
import UserSearchDialog from "../components/UserSearchDialog";
import { useFriends } from "../contexts/FriendsContext";
import { ACCOUNT_MENU_ITEMS, canAccessMenuItem } from "../navigation/menuConfig";
import { colors, layout, typography } from "../design/tokens";

const ACCENT = colors.primary;

// Life Circle logo mark inline SVG

export default function Header({ user, onLogout, onMenuClick, supportAction }) {
  const { friends } = useFriends();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [searchOpen, setSearchOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const moreMenuId = React.useId();

  const visibleAccountItems = ACCOUNT_MENU_ITEMS.filter((item) => canAccessMenuItem(user, item));

  // Desktop: header is hidden â€” LeftNav handles all navigation
  if (!isMobile && !supportAction) return null;

  return (
    <>
      <AppBar position="sticky" elevation={0} sx={{
        backgroundColor: colors.surface,
        borderBottom: `1px solid ${colors.border}`,
        top: 0,
        zIndex: 1100,
      }}>
        <Toolbar sx={{ justifyContent: "space-between", minHeight: 52, px: 2 }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 8 }}>
            <LogoMark size={36} />
            <Box component="span" sx={{
              fontFamily: typography.serif,
              fontSize: "16px",
              color: colors.text,
              lineHeight: 1,
              "& em": { color: ACCENT, fontStyle: "italic" },
            }}>
              Life <em>Circle</em>
            </Box>
          </Link>

          {/* Right actions, including support on desktop and mobile. */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {supportAction}
            <IconButton aria-label="Search people and Circles" onClick={() => setSearchOpen(true)} sx={{
              width: layout.touchTarget, height: layout.touchTarget,
              backgroundColor: colors.surfaceSubtle,
              border: `1px solid ${colors.border}`,
              borderRadius: "50%",
            }}>
              <SearchIcon sx={{ fontSize: 20, color: colors.textSecondary }} />
            </IconButton>

            {user && (
              <>
                <Tooltip title="More">
                  <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{
                    width: layout.touchTarget, height: layout.touchTarget,
                    backgroundColor: colors.surfaceSubtle,
                    border: `1px solid ${colors.border}`,
                    borderRadius: "50%",
                    p: 0,
                  }} aria-label="Open more navigation" aria-haspopup="menu" aria-expanded={open} aria-controls={open ? moreMenuId : undefined}>
                    <MenuIcon sx={{ fontSize: 20, color: colors.textSecondary }} />
                  </IconButton>
                </Tooltip>
                <Menu
                  id={moreMenuId}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  onClick={() => setAnchorEl(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  PaperProps={{ sx: { mt: 0.5, minWidth: 180 } }}
                  MenuListProps={{ "aria-label": "More navigation" }}
                >
                  {visibleAccountItems.map((item) => (
                    <MenuItem
                      key={item.key}
                      component={item.to ? NavLink : "li"}
                      to={item.to}
                      onClick={item.action === "logout" ? onLogout : undefined}
                      sx={{
                        minHeight: { xs: layout.touchTarget, sm: layout.touchTarget },
                        minWidth: layout.touchTarget,
                        fontSize: "14px",
                        fontFamily: typography.sans,
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <UserSearchDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        friends={friends || []}
        currentUserId={user?.id}
      />

    </>
  );
}
